<template>
  <wrapper-preview-category>
    <p class="mb-2 ml-4">Фильтры: </p>
    <v-row dens class="form-sort">
      <input
        type="search"
        class="cms-panel-search__input input-sort"
        v-model="searchOrg"
        placeholder="Поиск по выбранному типу"
      />
      <div class="second-sort">
        <v-col class=" d-flex align-start status px-0 py-0">
          <v-select
            label="Тип поиска"
            :items="searchFields"
            v-model="selectedSearchField"
            class="cms-panel-search__sort search-type mr-5"
          />
        </v-col>
        <v-col class="status-sort">
          <v-autocomplete multiple label="Статусы заявок" v-model="currentStatus" :items="statusArr"></v-autocomplete>
        </v-col>
        <v-col cols="3" class="dates pt-6">

          <v-menu
            ref="menu"
            v-model="menu"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-combobox
                class="dates-sort"
                v-model="dates"
                multiple
                chips
                dense
                label="Выбрать даты"
                small-chips
                readonly
                v-bind="attrs"
                v-on="on"
              ></v-combobox>
            </template>
            <v-date-picker
              v-model="dates"
              multiple
              locale="ru"
              no-title
              scrollable
            >
            </v-date-picker>
          </v-menu>
        </v-col>
        <v-autocomplete label="Сортировка" class="org-sort" v-model="currentSort" :items="sort"></v-autocomplete>
        <v-autocomplete label="Сортировка" v-model="currentSortDir" :items="sortDir"
                        class=" heigh-sort mx-3"></v-autocomplete>
        <v-btn class="blue__v-btn" @click="sortData">Сортировать</v-btn>
      </div>
    </v-row>
    <v-progress-linear indeterminate color="#00599b" v-if=" loading"></v-progress-linear>
    <div v-else-if="!appeals.length && !resultSearch.data.length" class="text-center">
      нет данных
    </div>
    <Alert alertType="primary" v-else-if="appeals.length && !resultSearch.data.length ">
      <template v-slot:icon>
        <v-icon :size="30" color="#084298">mdi-information-outline</v-icon>
      </template>
      <template v-slot:default>Поиск не дал результатов</template>
    </Alert>
    <div v-else>
      <CardFormFiveAppeal
        v-for="(appeal) of resultSearch.data"
        :key="appeal.id + appeal.org.id"
        :item="appeal"
        @openAboutAppeal="onOpenAboutAppeal($event)"
      />
      <div class="mt-3 d-flex flex-row justify-center align-center">
        <v-autocomplete
          class="pagination-table"
          v-model="userPages"
          :items="pagesPaginate"
          solo
          dense
          filled
          height="все"
          :length="pagesVuetify"
          rounded
          style="max-width: 150px"
          @change="changePage($event)"
        ></v-autocomplete>
        <v-pagination
          v-model="page"
          :length="pagesVuetify"
          :total-visible="7"
          @input="changePage($event)"
        >
        </v-pagination>
      </div>
    </div>
    <v-dialog
      v-model="modalOpen"
    >
      <v-card>
        <v-card-text class="pt-3">
          <template v-if="activeAppeal">
            <div class="appeal__header">
              <div class="appeal__container-flex">
                <div class="appeal__property">
                  Форма | поле | id Вуза:
                  <span class="appeal__span">{{ dialogCellInfo.idForm }} | {{
                      dialogCellInfo.idOriginal
                    }} | {{ activeAppeal.org.id }}</span>
                </div>
                <div class="appeal__property">
                  Наименование организации:
                  <span class="appeal__span">{{ activeAppeal.org.name }}</span>
                </div>
                <div class="appeal__property">
                  Форма обучения | адрес:
                  <span class="appeal__span">{{ dialogCellInfo.form + ' ' + dialogCellInfo.address }}</span>
                </div>
                <div class="appeal__property">
                  Наименование поля:
                  <span class="appeal__span">{{ dialogCellInfo.name + ' ' + dialogCellInfo.ist }}</span>
                </div>
                <div class="appeal__property">
                  Дата создания:
                  <span class="appeal__span">{{ activeAppeal.date }}</span>
                </div>
              </div>

              <div class="appeal__container-mainData">
                <v-row dense class="appeal__mainData">
                  <v-col class="appeal__mainData-item" style="min-width: 50%">УГСН</v-col>
                  <v-col class="appeal__mainData-item" style="max-width: 150px">Старое значение</v-col>
                  <v-col class="appeal__mainData-item" style="max-width: 150px">Новое значение</v-col>
                  <v-col class="appeal__mainData-item" style="max-width: 50px"></v-col>
                  <v-col class="appeal__mainData-item" style="max-width: 50px"></v-col>
                </v-row>

                <v-row dense class="mb-1" v-for="(item) of activeAppeal.data" :key="item.id+'appeal'">
                  <div
                    :class="{'done-row': item.accept === true, 'err-row': item.accept === false, '': item.accept === undefined}"
                    class="d-flex align-center appeal__span row-box">
                    <v-col class="appeal__mainData-item text-left" style="min-width: 50%">
                      {{ calcUgsnInfo(item.kcpGroup) }}
                    </v-col>
                    <v-col class="appeal__mainData-item" style="max-width: 150px">
                      {{ item.oldValue != null ? item.oldValue : 'н.д.' }}
                    </v-col>
                    <v-col class="appeal__mainData-item appeal__mainData-item-editable" style="max-width: 150px">
                      <input class="appeal__mainData-input" type="text" v-model="item.newValue">
                    </v-col>
                    <v-col
                      v-if="item.accept === true"
                      class="appeal__mainData-item appeal__mainData-action "
                      :class="item.accept === true ? 'appeal__mainData-action-selected text-decoration-underline' : ''"
                      @click="changeAppealStatus(item, true)"
                      style="max-width: 50px"
                    >

                    </v-col>
                    <v-col
                      v-else
                      class="appeal__mainData-item appeal__mainData-action "
                      :class="item.accept === true ? 'appeal__mainData-action-selected text-decoration-underline' : ''"
                      @click="changeAppealStatus(item, true)"
                      style="max-width: 50px"
                    >
                      <v-icon :size="30" color="#00599B">
                        mdi-check
                      </v-icon>
                    </v-col>
                    <v-col
                      v-if="item.accept === false"
                      class="appeal__mainData-item appeal__mainData-action"
                      :class="item.accept === false ? 'appeal__mainData-action-selected text-decoration-underline' : ''"
                      @click="changeAppealStatus(item, false)"
                      style="max-width: 50px"
                    >
                    </v-col>
                    <v-col
                      v-else
                      class="appeal__mainData-item appeal__mainData-action"
                      :class="item.accept === false ? 'appeal__mainData-action-selected text-decoration-underline' : ''"
                      @click="changeAppealStatus(item, false)"
                      style="max-width: 50px"
                    >
                      <v-icon :size="30" color="#00599B">mdi-close</v-icon>
                    </v-col>
                  </div>
                </v-row>
              </div>
              <div>
                Описание:
                <div class="d-flex span-box">
                  <p v-for="(item) in descriptionActiveAppeal" :key="item.id+'description'"
                     class="d-flex align-center mb-1  appeal__span mx-1 my-1 desc-span">{{
                      checkForUndefined(item)
                    }}</p>
                </div>
                <WrapperCollapse title="Файлы описаний" initial-close>
                  <div>
                    <v-btn
                      v-for="file in files"
                      :key="file +'file'"
                      class=" blue__v-btn mx-1 my-1"
                      :loading="loadingFile"
                      @click="downloadFile(file.file)"
                    >{{ file + file ? file.appeal : 'файл не приложен' }}
                    </v-btn>
                  </div>
                </WrapperCollapse>
              </div>

              <div class="appeal__property mt-2">
                Основание отказа:
                <div>
                  <textarea placeholder="Введите основание для отказа" v-model="decision"
                            class="appeal__input back-color" style="width: 100%" rows="4"></textarea>
                </div>
                Описание отказов:
                <div class="d-flex span-box">
                  <p v-for="(item) in decisionActiveAppeal" :key="item.id+'decision'"
                     class="d-flex align-center mb-1  appeal__span mx-1 my-1 desc-span">
                    {{ checkForUndefined(item) }}</p></div>
              </div>
              <div class="appeal__container-flex">
                <div class="appeal__property">
                  Статус:
                  <span class="appeal__span">{{ status.text }}</span>
                </div>
                <div class="appeal__property" v-if="this.activeAppeal.accept !== null">
                  Дата принятия решения:
                  <span class="appeal__span">{{ activeAppeal.dateReason }}</span>
                </div>
              </div>
              <div class="appeal__property appeal__actions"></div>
            </div>
          </template>
        </v-card-text>
      </v-card>
    </v-dialog>
  </wrapper-preview-category>
</template>

<script>
import {headerTooltipFunctions} from "@/mixins/forms5/headerTooltip";
import Alert from "@/components/cards/Alert";
import CardFormFiveAppeal from "@/components/cards/CardFormFiveAppeal";
import {tablePagination} from "@/mixins/tablePagination";
import AdminController from "@/controllers/AdminController";
import {sortArr} from "@/utils/helpers";
import AppealController from "@/controllers/Organizations/AppealController";
import WrapperPreviewCategory from "@/components/wrappers/WrapperPreviewCategory";
import {setFileFunctions} from "@/mixins/fileFucntions";
import {mapActions} from "vuex";
import utils from "@/utils/utils";
import WrapperCollapse from "../../components/wrappers/WrapperCollapse.vue";

export default {
  name: "FormsFiveAppeals",
  components: {WrapperPreviewCategory, CardFormFiveAppeal, Alert, WrapperCollapse},
  mixins: [headerTooltipFunctions, tablePagination, setFileFunctions],
  data() {
    return {
      appeals: [],
      serverData: [],
      decision: '',
      activeAppeal: null,
      activeAppealFile: '',
      searchOrg: '',
      searchFields: [
        {value: 'id', text: 'ID',},
        {value: 'name', text: 'Организация',},
        {value: 'uuid', text: 'UUID'},
      ],
      selectedSearchField: 'name',
      menu: false,
      dates: [],
      sort: [
        {text: 'id организации', value: 'orgId', type: 'number'},
        {text: 'Наименование организации', value: 'id', type: 'string'},
        {text: 'date create', value: 'date', type: 'date'},
        {text: 'status', value: 'accept', type: 'boolean'},
        // {text: 'id', value: 'id'},
      ],
      sortDir: [
        {text: 'По убыванию', value: 'asc'},
        {text: 'По возрастанию', value: 'desc'},
      ],
      statusArr: [
        // {text: 'Все заявки', value: 1},
        {text: 'На рассмотрении', value: null},
        {text: 'Удовлетворена', value: true},
        {text: 'Отказано', value: false},
      ],
      results: 0,
      loading: false,
      loadingFile: false,
      currentStatus: [true, false, null],
      currentSort: 'id',
      currentSortDir: 'desc',
      paginatorParams: {'selectedPage': 1, 'itemsPerPage': 10},
      modalOpen: false,
    }
  },
  computed: {
    // dateCreate() {
    //   return this.activeAppeal.createDate
    // },
    // dateEdit() {
    //   return this.activeAppeal.changeDate
    // },

    files() {
      return this.activeAppeal.data
    },
    selectedField() {
      switch (this.selectedSearchField) {
        case "id":
          return 'id';
        case 'name':
          return 'name';
        case 'uuid':
          return 'uuid';
        default:
          return 'name';
      }

    },
    descriptionActiveAppeal() {
      if (!this.activeAppeal?.data)
        return null;
      return this.activeAppeal.data.map(el => {
        return {id: el.id, text: el.appeal, kcp: this.calcUgsnInfoCode(el.kcpGroup)}
      });
    },
    decisionActiveAppeal() {
      if (!this.activeAppeal?.data)
        return null;
      return this.activeAppeal.data.map(el => {
        return {id: el.id, text: el.decision ?? '', kcp: this.calcUgsnInfoCode(el.kcpGroup)}
      });
    },
    dialogCellInfo() {
      const findItem = this.findInfoForCell(this.activeAppeal.jsonId);
      return {
        idForm: findItem?.idForm,
        idOriginal: findItem.idOriginal,
        name: findItem?.name,
        ist: findItem?.ist,
        form: findItem?.form,
        address: findItem?.address
      }
    },
    resultSearch() {
      let results;
      let array = this.serverData.filter((item) => {
        // if (this.currentStatus === 1) return item;
        // ради "Есть нерассмотренные"
        if (this.currentStatus.includes(null) && item?.data?.find(el => el.accept === null))
          return item
        if (this.currentStatus.includes(item.accept))
          return item;
      });
      let search = this.searchOrg;
      if (!search && this.dates.length === 0) {
        results = array.length;
        array = utils.divideArrayInPages(array, this.page, this.userPages)
        return {'data': array, 'counter': results};
      }
      let filterFn = null;
      search = search.trim().toLowerCase();
      switch (this.selectedField) {
        case "id":
          filterFn = (item) => {

            const itemId = String(item.org.id).toLowerCase();
            const searchId = String(search).toLowerCase();

            if (itemId === searchId) {
              return item
            }
          };
          break;
        case 'name':
          filterFn = (item) => {
            if (String(item.org[this.selectedField]).toLowerCase().indexOf(search) !== -1) {
              return item;
            }
          };
          break;
        case 'uuid':
          filterFn = (item) => {
            if (item.data.find(el => el.id === search)) {
              return item;
            }
          };
          break;
        default:
          filterFn = (item) => {
            if (String(item.org[this.selectedField]).toLowerCase().indexOf(search) !== -1) {
              return item;
            }
          };
          break;
      }
      if (this.dates.length > 0) {
        filterFn = (item) => {
          const mappedDateArr = item.data.map(el => {
            return el.date?.slice(0, 10)
          });
          if (item?.date && (this.dates.includes(item.date.slice(0, 10)) || this.dates.some(el => mappedDateArr.includes(el)))) {
            return item;
          }
        };
      }
      array = array.filter((item) => {
        const res = filterFn(item);
        if (res) return res
      })

      results = array.length;
      array = utils.divideArrayInPages(array, this.page, this.userPages)
      return {'data': array, 'counter': results};

    },
    appealType() {
      let appealType;
      switch (this.activeAppeal.appealType) {
        case 'SOURCE_DATA_ERROR':
          appealType = 'Апелляция на ошибку в исходных данных';
          break;
        case 'INDICATORS_VALUE_ERROR':
          appealType = 'Апелляция на ошибку в расчете значения показателя';
          break;
        case 'SUMMARY_RATING_ERROR':
          appealType = 'Апелляция на ошибку в расчете сводной оценки';
          break;
        case 'NORMALIZED_RATING_ERROR':
          appealType = 'Апелляция на ошибку в расчете нормированной оценки';
          break;
      }
      return appealType;
    },
    status() {
      const elementsActive = this.activeAppeal.data.filter(el => el.accept === null);
      const elementsAgreed = this.activeAppeal.data.filter(el => el.accept === true);
      const elementsDecline = this.activeAppeal.data.filter(el => el.accept === false);
      const lengthData = this.activeAppeal.data.length;
      if (elementsActive.length === lengthData)
        return {
          text: 'На рассмотрении',
          style: 'appeal_not-set'
        }
      else if (elementsAgreed.length === lengthData)
        return {
          text: 'Удовлетворена',
          style: 'appeal_accepted'
        }
      else if (elementsDecline.length === lengthData) {
        return {
          text: 'Отказано',
          style: 'appeal_rejected'
        }
      } else {
        return {
          text: 'Частично принята',
          style: 'appeal_rejected'
        }
      }
    },
  },
  created() {
    this.getAllAppeals();

  },
  methods: {
    ...mapActions('notifications', {addNotification: 'addNotification'}),
    prevPage() {
      if (this.paginatorParams.selectedPage > 1) this.paginatorParams.selectedPage -= 1
    },
    calcUgsnInfoCode(kcp) {
      if (!kcp)
        return;
      return kcp.code;
    },
    calcUgsnInfo(kcp) {
      if (!kcp)
        return;
      return kcp.code + ' ' + kcp.name;
    },
    nextPage() {
      if ((this.paginatorParams.selectedPage * this.paginatorParams.itemsPerPage) < this.resultSearch.length) this.paginatorParams.selectedPage += 1
    },
    changeAppealStatus(item, flag) {
      if (flag === false && this.decision) {

        AppealController.closeAppeal({
          id: item.id,
          newValue: item.newValue,
          reason: flag,
          decision: this.decision
        }).then(res => {
          console.log(res)
          const ind = this.activeAppeal.data.findIndex(el => res?.id === el.id);
          if (ind !== -1)
            this.activeAppeal.data.splice(ind, 1, res);
        })
      } else if (flag === true) {

        AppealController.closeAppeal({
          id: item.id,
          newValue: item.newValue,
          reason: flag,
          decision: this.decision
        }).then(res => {
          console.log(res)
          const ind = this.activeAppeal.data.findIndex(el => res?.id === el.id);
          if (ind !== -1)
            this.activeAppeal.data.splice(ind, 1, res);
        })
      } else
        this.addNotification({
          notificationStatus: 'error',
          notificationMessage: 'Заполните поле причины отказа',
          timeout: 5000
        })
    },
    getAllAppeals() {
      this.loading = true;
      AdminController.getFormFivesAppeals()
        .then(data => this.serverData = data)
        .finally(() => this.loading = false)
    },

    onOpenAboutAppeal(event) {
      this.modalOpen = true;
      this.activeAppeal = event;
    },
    sortData() {
      const item = this.sort.find(el => el.value === this.currentSort)
      this.serverData = sortArr(this.serverData, this.currentSort, this.currentSortDir, item.type);
    },
    checkForUndefined(item) {
      if (item.kcp === undefined || item.text === undefined) {
        return "Данные отсутствуют"
      } else {
        return item.kcp + ': ' + item.text
      }
    }
  }

}
</script>

<style scoped>
.form-sort {
  display: flex;
  flex-direction: column;

}

.second-sort {
  display: flex;
  align-items: center;
  justify-content: space-around;
}

.status {
  max-width: 160px;
}

.status-sort {
  max-width: 460px;
  max-height: 100px;
}

.search-type {
  max-width: 140px;
}

.input-sort {
  border: 1px solid grey;
  margin: 10px 10px 10px 30px;
  padding: 6px;
  border-radius: 3px;
  border: 1px solid black;
  width: 1710px;
}

.underline:hover {
  border-bottom: 1px solid black;
}

.underline::placeholder {
  font-size: 15px;
}

.dates {
  max-width: 150px
}

.dates-sort {
  max-width: 127px;
}

.org-sort {
  max-width: 270px;
}

.heigh-sort {
  max-width: 170px;
}

.done-row {
  background: #EBF9EB;
  border: 1px solid #8FE28E;
  color: #29A128
}

.err-row {
  background: #FDEBEB;
  border: 1px solid #F89B9B;
  color: #ED393E;
}

.row-box {
  border-radius: 4px;
  height: 40px;
}

.desc-span {
  max-width: 115px;
  white-space: nowrap;

  padding-left: 3px;
  box-sizing: border-box;
}

.span-box {
  flex-wrap: wrap;
  width: 100%;
  max-height: 100%;


}

.back-color {
  border: 1px solid rgb(0, 89, 155);
  border-radius: 4px;
}

.back-color::placeholder {
  padding: 5px;
  font-size: 15px;
}
</style>